<div class="flex flex-col gap-2">
  <label class="form-label"> {{ label }} </label>
  <input
    [type]="type"
    [formControl]="control"
    [placeholder]="placeholder"
    [ngClass]="{ 'form-input--error': isFieldInvalid() }"
    class="form-input"
  />
  @if (isFieldInvalid()) {
  <span class="form-span--error">Ce champ est requis</span>
  }
</div>
